import { useQuery } from '@tanstack/react-query'
import { BACKUP } from '../constants/endpoints'
import { getBackupLogs } from '../utils/getBackupLogs'
import { useAuthStore } from '@/features/auth/store/authStore'

export const useBackupLogsQuery = () => {
  const authedUser = useAuthStore((state) => state.user)
  return useQuery({
    queryKey: [BACKUP, authedUser?._id as string],
    queryFn: getBackupLogs,
    enabled: !!authedUser,
  })
}
